<div class="dialog-container">
    <div mat-dialog-title class="dialog-title">
        <span>사용자 조회</span>
        <button mat-icon-button class="close-icon">
            <mat-icon mat-dialog-close>close</mat-icon>
        </button>
    </div>
    <div mat-dialog-content class="dialog-content">
        <div class="user-list">
            <mat-list *ngIf="userInfoList.length > 0">
                <mat-list-item role="listitem" 
                    *ngFor="let userInfo of userInfoList"
                    (click)="onUserSelected(userInfo)">
                    <mat-icon matListIcon>account_circle</mat-icon>
                    <span matLine>
                        [{{userInfo.orgInfo.orgName}}] <br>
                        {{userInfo.id}} / {{userInfo.name}} {{userInfo.empTitleName}}
                    </span>
                    <mat-divider></mat-divider>
                </mat-list-item>
            </mat-list>
            <div class="empty-text-container" *ngIf="userInfoList.length === 0">
                <span>조회된 사용자가 없습니다.</span>
            </div>
        </div>
    </div>
    <!-- <mat-dialog-actions align="end">
        <button mat-raised-button [mat-dialog-close]="userInfo" color="primary">확인</button>
    </mat-dialog-actions> -->
</div>
